/* eslint-disable node/no-unsupported-features */
/* eslint max-len: ["error", { "code": 120, "tabWidth": 4 }] */
export default {
    locale: 'it',
    title: 'Application & Data Management',
    tool: 'Telomere tool',
    home: 'Home',
    about: 'Chi siamo',
    blog: 'Blog',
    feed: 'Tweets',
    contact: 'Contatti',
    notFound: 'pagina non trovata',
    offlineTitle: 'Offline',
    offline: 'nessuna connessione a internet',
    italian: 'Italiano',
    english: 'Inglese',
    theme: 'Tema Dark',
    company: 'Web Devotion OÜ',
    headquarter: 'Milano - Berlino - Tallin',
    privacy: 'privacy',
    terms: 'solo per uso interno',
    username: 'utente',
    password: 'password',
    login: 'Accedi',
    messagelogin: 'Inserire Utente e Password',
    errorlogin: 'Credenziali errate',
    notAllowed: 'operazione non permessa',
    errcalcTelomere: 'errore nel calcolo dei telomeri',
    loginExpired: 'login scaduto',
    logout: 'Esci',
    age: 'età',
    sex: 'sesso',
    male: 'maschio',
    female: 'femmina',
    length: 'kilobasi telomero',
    calculate: 'Calcola',
    errorTelomereAge: 'L\'età deve essere compresa tra 0 e 150',
    errorTelomereLength: 'La lunghezza deve essere maggiore di 0 e minore di 10',
    errorTelomere: 'Dati non corretti',
    top20Algo: 'età biologica top20',
    mediaAlgo: 'età biologica media',
    bottom20Algo: 'età biologica bottom20',
    averageLengthForAge: 'lunghezza media età',
    bruteForceAlgo: 'età biologica g',
    top20AlgoEXP: 'età biologica top20 exp',
    mediaAlgoEXP: 'età biologica media exp',
    bottom20AlgoEXP: 'età biologica bottom20 exp',
    algorithmG: 'algoritmo g',
    algorithmLab: 'algoritmo lab',
    algorithmExp: 'algoritmo logaritmo',
    telomereMLAge: 'algoritmo ML',
    suggestedAge: 'età suggerita',
    baseData: 'dati base',
    lengthMean: 'lunghezza media',
    ageMean: 'età media',
    telomereMLLength: 'lunghezza ML',
    lengthDeviation: 'deviazione standard',
    lengthDeviationWarning: 'warning deviazione standard',
};



// WEBPACK FOOTER //
// ./src/constants/locale-it.js